export const AGE_RANGE_UNSPECIFIED = 'AGE_RANGE_UNSPECIFIED'
export const AGE_RANGE_UNKNOWN = 'AGE_RANGE_UNKNOWN'
export const AGE_RANGE_18_24 = 'AGE_RANGE_18_24'
export const AGE_RANGE_25_34 = 'AGE_RANGE_25_34'
export const AGE_RANGE_35_44 = 'AGE_RANGE_35_44'
export const AGE_RANGE_45_54 = 'AGE_RANGE_45_54'
export const AGE_RANGE_55_64 = 'AGE_RANGE_55_64'
export const AGE_RANGE_65_PLUS = 'AGE_RANGE_65_PLUS'
